import AppRoute from "src/Modules/routes";

import AppLayout from "src/Layout";

import DemoLogin from "src/Auth";

type Props = {
  path: string;
  Component: React.FunctionComponent<Record<string, never>>;
  Layout: React.FunctionComponent<any>;
  useAuth: boolean;
};

export const BASE_ROUTES: Props[] = [
  {
    path: `/login`,
    Component: DemoLogin,
    Layout: null,
    useAuth: false,
  },
  {
    path: `/*`,
    Component: AppRoute,
    Layout: AppLayout,
    useAuth: true,
  },
];
